const translations = {
  "en": {
    "Action": "Action",
    "Asset": "Asset",
    "Chg(Shares)": "Chg(Shares)",
    "Latest Filing:": "Latest Filing:",
    "Latest Moves": "Latest Moves",
    "Loading...": "Loading...",
    "View Full History": "View Full History"
  },
  "zh-tw": {
    "Action": "操作",
    "Asset": "資產",
    "Chg(Shares)": "變動股數",
    "Latest Filing:": "最新披露：",
    "Latest Moves": "最新操作",
    "Loading...": "載入中...",
    "View Full History": "查看完整歷史"
  }
};

export default translations;
